import '../css/style-1.css';
import '../css/style-2.css';
import '../css/style.css';


function AboutWcu(){
 
    return(
        <> 
            <section className="homeWhyChooseSection">
                <div className="container">
                    <div className="row text-center mb-5">
                    <div className="col-12">
                        <h2 className="homeWhyChooseTitle">Why Choose Liya Realty</h2>
                        <p className="homeWhyChooseSubtitle">
                        We don’t just sell properties — we build trust, relationships, and long-term value.
                        </p>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-4 mb-4">
                        <div className="homeWhyChooseCard">
                        <div className="homeWhyChooseIcon">
                            <i className="fas fa-handshake"></i>
                        </div>
                        <h5>Transparency & Trust</h5>
                        <p>
                            Every transaction is handled with complete clarity and honest communication,
                            ensuring peace of mind for our clients.
                        </p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-4">
                        <div className="homeWhyChooseCard">
                        <div className="homeWhyChooseIcon">
                            <i className="fas fa-chart-line"></i>
                        </div>
                        <h5>Proven Track Record</h5>
                        <p>
                            Since 2018, we have successfully delivered multiple residential and commercial
                            projects with measurable growth and client satisfaction.
                        </p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-4">
                        <div className="homeWhyChooseCard">
                        <div className="homeWhyChooseIcon">
                            <i className="fas fa-home"></i>
                        </div>
                        <h5>End-to-End Support</h5>
                        <p>
                            From property consultation to home loans and portfolio management,
                            we guide you at every step of your investment journey.
                        </p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-4">
                        <div className="homeWhyChooseCard">
                        <div className="homeWhyChooseIcon">
                            <i className="fas fa-users"></i>
                        </div>
                        <h5>Customer-First Approach</h5>
                        <p>
                            Your goals are our priority. We tailor solutions that align perfectly
                            with your needs and long-term vision.
                        </p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-4">
                        <div className="homeWhyChooseCard">
                        <div className="homeWhyChooseIcon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h5>Multi-City Presence</h5>
                        <p>
                            With projects across multiple cities, we offer diverse property
                            opportunities in high-growth locations.
                        </p>
                        </div>
                    </div>

                    <div className="col-md-4 mb-4">
                        <div className="homeWhyChooseCard">
                        <div className="homeWhyChooseIcon">
                            <i className="fas fa-award"></i>
                        </div>
                        <h5>Professional Excellence</h5>
                        <p>
                            Our experienced team ensures credibility, commitment,
                            and seamless execution in every deal.
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </section>
           
        </>
    );
}

export default AboutWcu;